<div class="gt-routes-list-containerss height-limit">
  <div class="form-style column" [style.backgroundColor]="'inherit'" [hidden]="isGridHidden">
    <div class="grid-view-container" style="padding: 16px">
      <div class="upperToolbar">
        <div class="selector-btn-group" style="display: flex; align-items: center; gap: 8px">
          <dx-select-box
            id="compTypeList"
            class="modull-select-box"
            [dataSource]="componentTypeLists"
            displayExpr="name"
            valueExpr="id"
            [(value)]="selectedTypeId"
            (onSelectionChanged)="onSelectionChanged($event)"
            i18n-placeholder="@@pleaseChoose"
            placeholder="Please Select"
            [searchEnabled]="true"
          >
          </dx-select-box>
          <app-gpd-button
            *ngIf="selectedTypeId"
            i18n-text="@@showAllComponents"
            text="Show All Components"
            icon="refresh"
            (onClick)="showAllComponents()"
            type="text"
          >
          </app-gpd-button>
        </div>
        <app-gpd-button
          i18n-text="@@addNewComponent"
          text="Add New Component"
          icon="add"
          (onClick)="addNewComponent()"
          style="justify-content: flex-end"
        ></app-gpd-button>
      </div>

      <div class="tc-grid-wrapper">
        <div class="custom-toolbar">
          <div class="custom-toolbar-left">
            <dx-text-box
              [(value)]="searchTerm"
              mode="search"
              (offClick)="doSearch($event)"
              valueChangeEvent="keyup"
              width="350px"
              (onValueChanged)="doSearch($event)"
              i18n-placeholder="@@componentsSearch"
              placeholder="Search components..."
              class="custom-search-panel"
            >
            </dx-text-box>
          </div>

          <!-- Right end of the toolbar (.custom-toolbar is space-between). -->
          <div class="switch-label-group">
            <dx-switch
              class="gt-switch"
              switchedOnText
              switchedOffText
              [width]="100"
              (onValueChanged)="onSwitchChange($event)"
              [(value)]="switchChanged"
            ></dx-switch>
            <span class="switch-label" i18n="@@inactiveComponents">Inactive Components</span>
          </div>
        </div>

        <div class="inner-grid-panel">
        <dx-data-grid
          [dataSource]="flattenedComponents"
          [width]="'100%'"
          height="100%"
          [allowColumnResizing]="true"
          [columnResizingMode]="'widget'"
          [columnAutoWidth]="false"
          [showBorders]="false"
          [selection]="{ mode: 'multiple', showCheckBoxesMode: 'always' }"
          [rowAlternationEnabled]="false"
          [scrolling]="{ mode: 'standard', useNative: false, showScrollbar: 'never' }"
          [hoverStateEnabled]="true"
          class="gpd-datagrid"
          [showColumnLines]="true"
          (onRowClick)="onRowClick($event)"
          (onContentReady)="onContentReady()"
          (onOptionChanged)="onHeaderFilterChanged()"
          (onRowPrepared)="onRowPrepared($event)"
          [paging]="{ enabled: true, pageSize: dynamicPageSize }"
          [pager]="{ showPageSizeSelector: false, allowedPageSizes: [dynamicPageSize], showInfo: false, visible: false
          }"
        >
          <dxo-header-filter [visible]="true"></dxo-header-filter>
          <dxi-column i18n-caption="@@model" caption="Model" dataField="model"></dxi-column>
          <dxi-column i18n-caption="@@type" caption="Type" dataField="type"></dxi-column>
          <dxi-column i18n-caption="@@manufacturer" caption="Manufacturer" dataField="manufacturerName"></dxi-column>
          <!-- <dxi-column i18n-caption="@@status" caption="Status" dataField="status" cellTemplate="statusCellTemplate">
          </dxi-column> -->
          <!-- <div *dxTemplate="let cell of 'statusCellTemplate'">
            <app-contracts-status-pill [statusId]="getStatusId(cell.value)"></app-contracts-status-pill>
          </div> -->
          <dxi-column *ngFor="let col of dynamicColumns" [dataField]="col.name" [caption]="col.name"></dxi-column>

          <dxi-column
            dataField=""
            [visible]="true"
            allowEditing=" false"
            cellTemplate="buttonCellTemplate"
            [width]="'auto'"
            [formItem]="{ visible: false }"
          >
            <div class="cell-with-buttons" *dxTemplate=" let item of 'buttonCellTemplate'">
              <div class="cell-button-container">
                <app-gpd-button icon="edit" type="text" (onClick)="directToEdit(item.row.data, $event)">
                </app-gpd-button>
              </div>
            </div>
          </dxi-column>
        </dx-data-grid>

        <!-- details page -->
        <app-component-details-panel
          [visible]="detailsPanelVisible"
          [componentDetails]="componentDetails"
          [doclinks]="doclinks"
          [componentId]="componentId"
          [documentList]="documentList"
          [sites]="sitesForPanel"
          [projects]="projectsForPanel"
          [disableDownloadAll]="disableDownloadAll"
          (onClose)="closeDetailsPanel()"
          (onEdit)="editComponent()"
          (onDownloadAll)="downloadZipped()"
        ></app-component-details-panel>
        <!-- end details page -->
        </div>

        <div class="bottom-toolbar">
          <app-gpd-button
            type="tertiary"
            icon="download"
            i18n-text="@@export"
            text="Export"
            (onClick)="exportComponentData()"
          ></app-gpd-button>

          <app-gpd-pagination
            [currentPage]="currentPage"
            [totalPages]="totalPages"
            [itemsPerPage]="itemsPerPage"
            [totalItems]="totalItemsForSelectedType"
            (onPageChange)="onPageChange($event)"
          ></app-gpd-pagination>
        </div>

      </div>

      <!-- end -->
    </div>
  </div>
  <div [hidden]="isFormHidden" class="tech-form-wrapper">
    <div class="tech-form-scroll-content">
    <div class="panel-form" style="padding: 16px">
      <dx-validation-group #techValidationGroup>
      <div class="gpd-form-grid">
        <div class="gpd-form-column">
          <div class="gpd-form-card">
            <div class="gpd-form-card-header">
              <app-svg-icon icon="layers" [color]="'var(--color-primary)'" [size]="24"></app-svg-icon>
              <span class="gpd-form-card-title" i18n="@@details">Details</span>
            </div>

            <div class="gpd-form-row">
              <div class="gpd-form-field">
                <label class="gpd-form-label gpd-form-required">Modell</label>
                <dx-text-box
                  class="gpd-input"
                  [(value)]="model"
                  i18n-placeholder="@@modelPlaceholder"
                  placeholder="Enter model designation"
                >
                  <dx-validator>
                    <dxi-validation-rule type="required" i18n-message="@@modelRequired" message="Model is Required"></dxi-validation-rule>
                  </dx-validator>
                </dx-text-box>
                <span
                  *ngIf="isEdit && isCompleted && (!model || model.trim() === '')"
                  class="field-required-error"
                  i18n="@@pleaseFillinField"
                  >Bitte Feld ausfüllen</span
                >
              </div>
              <div class="gpd-form-field">
                <label class="gpd-form-label gpd-form-required">Typ</label>
                <dx-select-box
                  [disabled]="disableType"
                  class="gpd-input"
                  i18n-placeholder="@@pleaseChoose"
                  placeholder="Please Select"
                  [dataSource]="componentTypeLists"
                  displayExpr="name"
                  valueExpr="id"
                  [(value)]="selectedTypeId"
                  (onSelectionChanged)="onComponentChosen($event)"
                >
                  <dx-validator>
                    <dxi-validation-rule type="required" i18n-message="@@typeRequired" message="Type is Required"></dxi-validation-rule>
                  </dx-validator>
                </dx-select-box>
              </div>
            </div>

            <!-- Manufacturer + the dynamic type fields always render two per row (left/right) -
                 detailFieldRows pairs them so a lone trailing field is the only exception. -->
            <div *ngFor="let row of detailFieldRows" class="gpd-form-row" [class.gpd-form-row--half]="row.length === 1">
              <div *ngFor="let field of row" class="gpd-form-field">
                <ng-container *ngIf="field.isManufacturerField; else dynamicFieldTpl">
                  <label class="gpd-form-label gpd-form-required">Hersteller</label>
                  <div class="contacts-dropdown-box-container" style="display: flex; align-items: center; width: 100%;">
                    <app-contacts-dropdown-box
                      class="app-contracts-dropdown-box"
                      style="flex: 1;"
                      [validationRequired]="true"
                      [persons]="[]"
                      [companies]="contacts.companies"
                      [allowSocieties]="false"
                      [contactId]="manufacturerId"
                      [contactType]="'company'"
                      (onContactSelected)="onManufacturerContactSelected($event)"
                      (onNewContactRequested)="onNewContactFromDropdown($event, 'manufacturer')"
                    ></app-contacts-dropdown-box>
                  </div>
                  <span
                    *ngIf="isEdit && isCompleted && !manufacturerId"
                    class="field-required-error"
                    i18n="@@pleaseFillinField"
                    >Bitte Feld ausfüllen</span
                  >
                </ng-container>
                <ng-template #dynamicFieldTpl>
                  <label class="gpd-form-label" [class.gpd-form-required]="field.required">
                    {{ field.displayName || field.name }}
                  </label>
                  <ng-container
                    *ngIf="field.type === 'contact' || field.type === 'CONTACT' || field.type === 'Contact' || field.type === 'Kontakt' || field.type === 'KONTAKT'"
                  >
                    <div class="contacts-dropdown-box-container" style="display: flex; align-items: center; width: 100%;">
                      <app-contacts-dropdown-box
                        class="app-contracts-dropdown-box"
                        style="flex: 1;"
                        [validationRequired]="field.required"
                        [persons]="contacts.persons"
                        [companies]="contacts.companies"
                        [contactId]="getContactIdForField(field)"
                        [contactType]="getContactTypeForField(field)"
                        (onContactSelected)="onContactFieldSelected(field, $event)"
                        (onNewContactRequested)="onNewContactFromDropdown($event, 'field', field)"
                      ></app-contacts-dropdown-box>
                    </div>
                  </ng-container>
                  <ng-container
                    *ngIf="field.type === 'number' || field.type === 'NUMBER' || field.type === 'Number' || field.type === 'Nummer' || field.type === 'NUMMER'"
                  >
                    <dx-number-box
                      class="gpd-input"
                      [(value)]="field.dataValue"
                      i18n-placeholder="@@numberPlaceholder"
                      placeholder="Number"
                    >
                      <dx-validator>
                        <dxi-validation-rule *ngIf="field.required" type="required" i18n-message="@@fieldIsRequired" message="This field is required"></dxi-validation-rule>
                      </dx-validator>
                    </dx-number-box>
                  </ng-container>
                  <ng-container
                    #textField
                    *ngIf="field.type === 'text' || field.type === 'TEXT' || field.type === 'Text';"
                  >
                    <dx-text-box
                      class="gpd-input"
                      [(value)]="field.dataValue"
                      i18n-placeholder="@@valuePlaceholder"
                      placeholder="Enter value"
                    >
                      <dx-validator>
                        <dxi-validation-rule *ngIf="field.required" type="required" i18n-message="@@fieldIsRequired" message="This field is required"></dxi-validation-rule>
                      </dx-validator>
                    </dx-text-box>
                  </ng-container>
                  <ng-container *ngIf="field.type === 'dropdown' || field.type === 'DROPDOWN';">
                    <dx-select-box
                      class="gpd-input"
                      [dataSource]="field.options"
                      [(value)]="field.dataValue"
                      i18n-placeholder="@@pleaseChoose"
                      placeholder="Please Select"
                    >
                      <dx-validator>
                        <dxi-validation-rule *ngIf="field.required" type="required" i18n-message="@@fieldIsRequired" message="This field is required"></dxi-validation-rule>
                      </dx-validator>
                    </dx-select-box>
                  </ng-container>
                  <span
                    *ngIf="isEdit && isCompleted && field.required && (!field.dataValue || field.dataValue === '')"
                    class="field-required-error"
                    i18n="@@pleaseFillinField"
                    >Bitte Feld ausfüllen</span
                  >
                </ng-template>
              </div>
            </div>
          </div>

          <div class="gpd-form-card">
            <div class="gpd-form-card-header gpd-form-card-header--actions">
              <span class="gpd-form-card-header__label">
                <app-svg-icon icon="document" [color]="'var(--color-primary)'" [size]="24"></app-svg-icon>
                <span class="gpd-form-card-title" i18n="@@documents">Documents</span>
              </span>
              <app-gpd-button
                *ngIf="isComponentTypeSelected && componentId && !disableDownloadAll"
                i18n-text="@@downloadAll"
                text="Download All"
                icon="download"
                type="text"
                (onClick)="downloadZipped()"
              ></app-gpd-button>
            </div>

            <p *ngIf="!isComponentTypeSelected" class="gpd-form-empty-hint" i18n="@@noDocumentsSelectTypeFirst">
              Please select a component type first to see which documents are needed.
            </p>

            <p *ngIf="isComponentTypeSelected && !hasDocumentsForSelectedType()" class="gpd-form-empty-hint" i18n="@@noDocumentsDefinedForType">
              No documents are defined for this component type.
            </p>

            <div class="upload-container" *ngIf="isComponentTypeSelected">
              <div class="doc-list">
                <ng-container *ngFor="let doc of documentList">
                  <div class="doc-list-row" *ngIf="doc.techComponentTypeId === selectedTypeId">
                    <span *ngIf="!hasDocLink(doc)" class="doc-list-name" [class.gpd-form-required]="doc.required">{{ doc.name }}</span>
                    <app-contracts-pill
                      *ngIf="hasDocLink(doc)"
                      [content]="getDocForPill(doc)"
                      [linkType]="'techDocument'"
                      [displayString]="doc.name"
                      [editable]="false"
                      (onPillClick)="viewCompDoc($event)"
                    ></app-contracts-pill>
                    <div class="doc-list-actions">
                      <button
                        *ngIf="hasDocLink(doc)"
                        type="button"
                        class="doc-list-icon-btn"
                        i18n-title="@@replace"
                        title="Replace"
                        (click)="showUploaderForDoc(doc)"
                      >
                        <app-svg-icon icon="refresh" [size]="16" color="var(--color-primary)"></app-svg-icon>
                      </button>
                      <app-gpd-button
                        *ngIf="!hasDocLink(doc)"
                        type="text"
                        icon="upload"
                        i18n-text="@@selectFile"
                        text="Select file"
                        (onClick)="showUploaderForDoc(doc)"
                      ></app-gpd-button>
                      <button
                        *ngIf="hasDocLink(doc)"
                        type="button"
                        class="doc-list-icon-btn doc-list-icon-btn--danger"
                        i18n-title="@@remove"
                        title="Remove"
                        (click)="removeCompDoc(getDocForPill(doc))"
                      >
                        <app-svg-icon icon="delete" [size]="16" color="var(--color-red-500)"></app-svg-icon>
                      </button>
                    </div>
                  </div>
                  <div
                    *ngIf="doc.techComponentTypeId === selectedTypeId && isMissingRequiredDoc(doc)"
                    class="gpd-field-error doc-list-error"
                    role="alert"
                  >
                    <app-svg-icon icon="alert" [size]="16" color="var(--color-text-error)"></app-svg-icon>
                    <span i18n="@@requiredDocumentMissing">This document is required.</span>
                  </div>
                </ng-container>
              </div>
              <input
                #docFileInput
                type="file"
                style="display: none"
                accept=".pdf,.doc,.docx,.jpg,.png,.jpeg,.avi,.xlsx"
                (change)="onDocFileInputChanged($event)"
              />
            </div>
          </div>
        </div>

        <div class="gpd-form-column gpd-form-column--side">
          <div class="gpd-form-card">
            <div class="gpd-form-card-header">
              <app-svg-icon icon="flag" [color]="'var(--color-primary)'" [size]="24"></app-svg-icon>
              <span class="gpd-form-card-title" i18n="@@status">Status</span>
            </div>
            <div class="gpd-form-row">
              <div class="gpd-form-field">
                <dx-select-box
                  class="gpd-input"
                  [dataSource]="statusOptions"
                  displayExpr="text"
                  valueExpr="value"
                  [(value)]="selectedStatus"
                  i18n-placeholder="@@pleaseChoose"
                  placeholder="Please Select"
                >
                </dx-select-box>
              </div>
            </div>
          </div>

          <div *ngIf="filteredProjectIds && filteredProjectIds.length > 0" class="gpd-form-card">
            <div class="gpd-form-card-header">
              <app-svg-icon icon="route" [color]="'var(--color-primary)'" [size]="24"></app-svg-icon>
              <span class="gpd-form-card-title" i18n="@@projects">Project List</span>
            </div>
            <div class="pill-container">
              <ng-container *ngFor="let projectId of filteredProjectIds; let i = index">
                <app-contracts-pill
                  [content]="{ projectId: projectId, projectName: filteredProjectNames[i], siteId: getSiteIdForProject(projectId) }"
                  [linkType]="'techProject'"
                  [displayString]="filteredProjectNames[i]"
                  [quantity]="filteredProjectQuantities[i]"
                  [projectStatus]="filteredProjectStatuses[i]"
                ></app-contracts-pill>
              </ng-container>
            </div>
          </div>

          <div *ngIf="filteredSiteIds && filteredSiteIds.length > 0" class="gpd-form-card">
            <div class="gpd-form-card-header">
              <app-svg-icon icon="location" [color]="'var(--color-primary)'" [size]="24"></app-svg-icon>
              <span class="gpd-form-card-title" i18n="@@site">Site</span>
            </div>
            <div class="pill-container">
              <ng-container *ngFor="let siteId of filteredSiteIds; let i = index">
                <app-contracts-pill
                  [content]="{ siteId: siteId, siteName: filteredSiteNames[i] }"
                  [linkType]="'techSite'"
                  [displayString]="filteredSiteNames[i]"
                  [quantity]="filteredSiteQuantities[i]"
                ></app-contracts-pill>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
      </dx-validation-group>
    </div>
    </div>

    <app-form-footer>
      <app-gpd-button
        *ngIf="isEdit"
        footerLeft
        i18n-text="@@delete"
        text="Delete"
        icon="delete"
        type="danger"
        (onClick)="deleteComponent()"
        [disabled]="!componentId"
      ></app-gpd-button>
      <app-gpd-button
        footerRight
        type="secondary"
        i18n-text="@@cancel"
        text="Cancel"
        icon="cancel"
        (onClick)="goBack()"
      ></app-gpd-button>
      <app-gpd-button
        footerRight
        i18n-text="@@save"
        text="Save"
        icon="check"
        (onClick)="saveTechComponent()"
        [disabled]="isSaveDisabled"
      ></app-gpd-button>
      <div footerRight class="complete-btn-wrapper">
        <app-gpd-button
          [text]="(isEdit && isCompleted) ? 'Fertiggestellt' : 'Fertigstellen'"
          icon="task-done"
          [disabled]="(isEdit && isCompleted) || !allRequiredFieldsFilled"
          (onClick)="completeComponent()"
        ></app-gpd-button>
        <span *ngIf="!allRequiredFieldsFilled" class="complete-btn-tooltip" i18n="@@completeButtonTooltip">
          Bitte füllen Sie alle Pflichtfelder aus, um die Komponente fertigzustellen.
        </span>
      </div>
    </app-form-footer>
  </div>

  <div *ngIf="showDeleteRestrictionPopup" class="gpd-overlay-center">
    <div>
      <span id="warning-icon" class="dx-icon-warning"></span>
    </div>
    <span style="color: black; font-size: 18px; margin-bottom: 18px; text-align: center">
      Die Komponente kann nicht gelöscht werden, da es mit Projekten verknüpft ist.<br />
      Bitte entfernen Sie Komponenten zuerst aus den Projekten, bevor Sie sie löschen.
    </span>
    <dx-button
      icon="check"
      text="Understood"
      i18n-text="@@understood"
      class="gpd-button"
      (onClick)="showDeleteRestrictionPopup = false"
    >
    </dx-button>
  </div>

  <div *ngIf="showErrMsg" class="gpd-overlay-center">
    {{errMsg}}
    <dx-button
      icon="check"
      text="Understood"
      i18n-text="@@understood"
      (onClick)="showErrMsg = false"
      class="gpd-button"
      style="margin-top: 15px"
    >
    </dx-button>
  </div>
</div>

<app-validation-toast #validationToast></app-validation-toast>

<app-contacts-popup
  class="dx-treevieweditor-overlay"
  [(visible)]="contactsPopupVisible"
  (onHiding)="contactsPopupVisible = false"
  [(companies)]="contacts.companies"
  [(persons)]="contacts.persons"
  (onContactSelected)="onPopupContactSelected($event)"
  (onContactAdded)="onPopupContactSelected($event)"
>
</app-contacts-popup>
